<template>
  <div class="page-wrapper">
    <div class="page-content-tab" :style="checkWidth ? pageContentWidth : mobPageContentWidth">
        <div class="container-fluid mob-container">
            <!-- Page-Title -->
            <div class="row">
                <div class="col-sm-12">
                    <div class="page-title-box">
                        <div class="float-right">
                            <!-- {{$route.name[0]}} -->
                            <ol class="breadcrumb">
                                <div v-for="( router, index) in $route.name" :key="router" >
                                    <li v-if="index !== 0" class="breadcrumb-item "></li>
                                    <li class="breadcrumb-item active">
                                    {{router}}
                                    </li>
                                </div>
                            </ol>
                        </div>
                        <h4 class="page-title">{{$route.name[$route.name.length-1]}}</h4>
                    </div>
                </div>
            </div>
            <!--end page-title-box-->
            <div class="row">
                <div class="col-12">

                </div> <!-- end col -->
            </div>
            <div class="row">
                <div class="col-12">
                    <!-- <div class="card"> -->
                    <slot></slot>
                    <!-- </div> -->
                </div>
            </div>
        </div>
        <footer class="footer text-center text-sm-left d-flex justify-content-between w-75">&copy; 2018 - 2022
            <span class="text-center text-muted d-none d-sm-inline-block">Crafted with
                <i class="mdi mdi-heart text-danger"></i> by
                <a href="https://www.proxoft.org/" target="_blank">Proxoft systems</a>
            </span>
        </footer>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            checkWidth : null,
        }
    },
    props: ['pageTitle', 'innerMenuWidth'],
    computed: {
        pageContentWidth() {
            return {width: `calc(100% - ${this.$store.getters['settings/innerMenuIsClosed'] ? '70px' : '(' + this.innerMenuWidth + ' + 70px)'})`}
        },
        mobPageContentWidth() {
            return {width: `calc(100% - ${this.$store.getters['settings/innerMenuIsClosed'] ? '72px' : '72px'})`}
        }
    },
    created() {
        window.addEventListener("resize", this.myEventHandler);
    },
    destroyed() {
        window.removeEventListener("resize", this.myEventHandler);
    },
    mounted(){
      if(window.innerWidth <= 1200){
        this.checkWidth = false
      }else{
        this.checkWidth = true
      }
    },
    methods: {
        myEventHandler(e) {
            if(e.target.innerWidth <= 1200){
               this.checkWidth = false
            }else{
                this.checkWidth = true
            }
        },
        consoleLog(data){
            console.log(data)
        },
    }
}
</script>
<style scoped>
  /*.page-content-tab{*/
  /*  width: calc(100% - 320px);*/
  /*}*/
  @media only screen and (max-width: 400px) {
    .mob-container{
        padding: 0 !important;
    }
    .page-title-box .page-title{
        font-size: 16px;
    }
    .page-content-tab{
        margin-left: 70px;
    }
  }
  
</style>
